import React, { useState, useEffect } from 'react';
import { StreamChat } from 'stream-chat';

import { ChatStreamContext } from './context';
import ChatCanalService from '../../Services/api/Chat';
import Utils from '../../Services/Utils';

const stream = require('getstream');

const ChatStreamContextProvider = (props) => {

  const [ options ] = useState({
    state: true,
    watch: true
  });
  const [ lastChannel, setlastChannel ] = useState(null);
  const [ accounts, setAccounts ] = useState([]);
  const [ currentUser, setCurrentUser ] = useState(null);
  const [ chatClient, setChatClient ] = useState(null);
  const [ filters, setFilters ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [ chatList, setChatList ] = useState(null);
  const [ selectedChannel, setSelectedChannel ] = useState(null);
  const [ selectedChannelActive, setSelectedChannelActive ] = useState(null);
  const [ selectedChannelExpand, setSelectedChannelExpand ] = useState(null);
  const [ memberList, setMemberList ] = useState([]);
  const [ showNotificationBanner, setShowNotificationBanner ] = useState(false);
  const [ totalMessagesUnread, setTotalMessagesUnread ] = useState([]);

  useEffect( () => {

    if (chatClient) {
      grantPermission();
      if (!chatList) {
        getChannelList();
      }
    }

    return () => {
      // This is intentional do_something blank function
    };
  }, [chatClient]);

  const setUser = async (token, apiKey, currentAccountUser, accounts) => {
    const { user } = currentAccountUser;
    const {
      id,
      first_name,
      last_name,
    } = user;
    let currentUser = null;
    let chatClient = new StreamChat(apiKey);
    const userSet = {
      id: String(id),
      name: `${first_name} ${last_name}`
    };

    try {
      currentUser = await chatClient.setUser(userSet, token);
    } catch(e) {
      console.log('setUser', e);
    }

    const filters = {
      members: { 
        $in: [String(id)] 
      } 
    };

    setAccounts(accounts);
    setFilters(filters);
    setCurrentUser(currentUser ? currentUser.me : currentUser);
    setChatClient(chatClient);
  };

  const clearChatContext = () => {
    setCurrentUser(null);
    setChatClient(null);
    setFilters(null);
    setChatList(null);
  };

  const grantPermission = () => {
    if (window.Notification) {
      if (Notification.permission === 'granted' || Notification.permission === 'denied') {
        setShowNotificationBanner(true);
        return;
      }

      if (Notification.permission !== 'denied' || Notification.permission === 'default') {
        Notification.requestPermission().then((result) => {
          if (result === 'granted') {
            setShowNotificationBanner(true);
          }
        });
      }
    }
  };

  const sortChannels = async (channels) => {
    let propertiesChat = [];
    let propertiesChatIds = [];
    let rolesChat = [];
    let rolesChatIds = [];
    let customChat = [];
    let customChatIds = [];

    for (let channel of channels) {
      const { data } = channel;
      const { typeChannel, name } = data;

      const dataChat = getChatChannelData(channel);
      channel.dataChat = dataChat;

      switch (typeChannel) {
        case 'property':
          if (!propertiesChatIds.includes(channel.id)) {
            propertiesChat.push(channel);
            propertiesChatIds.push(channel.id);
          }
          break;
        case 'role':
          if (!rolesChatIds.includes(channel.id)) {
            rolesChat.push(channel);
            rolesChatIds.push(channel.id);
          }
          break;
        case 'direct':
        case 'group':
          if (!customChatIds.includes(channel.id)) {
            customChat.push(channel);
            customChatIds.push(channel.id);
            if (name !== dataChat.directChatName) {
              await channel.update({
                name: dataChat.directChatName,
                typeChannel: typeChannel,
              });
            }
          }
          break;
      }
    }

    const chatList = [
      {
        title: 'Properties',
        type: 'property',
        data: propertiesChat
      },
      {
        title: 'User Role',
        type: 'role',
        data: rolesChat
      },
      {
        title: 'Direct Messages',
        type: 'custom',
        data: customChat
      }
    ];
    setChatList(chatList);
    return chatList;
  };

  const getChannelList = async () => {
    if(!chatClient) {
      return;
    }

    let limit = 30;
    let offset = 0;
    let count = limit;
    let channelTotal = [];

    while(count === limit) {
      const options = {
        limit: limit,
        offset: offset,
        message_limit: 100
      };
      const channels = await chatClient.queryChannels(filters, {last_message_at: -1}, options);
      count = channels.length;
      offset += limit;
      channelTotal = [...channelTotal, ...channels];
      const channelList = await sortChannels(channelTotal);
      updateTotalMessagesUnread(channelList);
      await Utils.sleep(3000);
    }
    return true;
  };

  const getChatChannelData = (channel) => {
    const { data, state} = channel;
    const { name, created_by } = data;
    const memberList = Object.values(state.members);
    const memberNumber  = memberList.length;
    const membersOnline = memberList.filter(({ user }) => user.online).length;

    const messagesUnread = state.read[currentUser.id] ?
          state.read[currentUser.id].unread_messages : 0;
    let directChatName = '' + name;
    let viewChatName = '' + name;
    if (checkChannelCustom(channel)) {
      directChatName = memberList.map(({user}) => user.name).join(', ');
      viewChatName = '';
      if (getChannelType(channel) === 'group') {
        viewChatName = '' + directChatName
      }
      else {
        memberList.forEach(({user}) => {
          if (user.id !== currentUser.id){
            viewChatName = '' + user.name;
          }
        });
      }
    }
    return {
      memberList,
      memberNumber,
      membersOnline,
      directChatName,
      viewChatName,
      messagesUnread,
      createdByUserId: created_by.id
    }
  };

  const getChannelType = (channel) => {
    const { data } = channel;
    const { typeChannel } = data;
    return typeChannel;
  };

  const checkChannelCustom = (channel) => {
    const typeChannel = getChannelType(channel);
    return !typeChannel || ['direct', 'group'].includes(typeChannel);
  };

  const updateChannelMessages = (chatID, numMessages) => {
    if (chatList) {
      chatList.map(({data}) => {
        data.map((channel)=> {
          if (channel.id === chatID) {
            channel.dataChat.messagesUnread = numMessages;
          }
        });
      });
      setChatList([...chatList]);
      if (selectedChannel) {
        selectedChannel.map((channel) => {
          if (channel.id === chatID) {
            channel.dataChat.messagesUnread = numMessages;
          }
        });
        setSelectedChannel([...selectedChannel]);
      }
      updateTotalMessagesUnread();
    }
  };

  const updateTotalMessagesUnread = (channelList) => {
    const list = channelList || chatList;
    let totalUnread = 0;
    if (list) {
      list.map(({data}) => {
        data.map((channel) => {
          let messagesUnread = 0;
          if (channel.dataChat) {
            messagesUnread = channel.dataChat.messagesUnread;
          } else {
            messagesUnread = (channel.state.read[currentUser.id] ? channel.state.read[currentUser.id].unread_messages : 0);
          };
          totalUnread += messagesUnread;
        });
      });
    }
    setTotalMessagesUnread(totalUnread);
  };

  const updateChannelList = async (chatId) => {
    if (chatList && chatId) {
      setLoading(true);
      const results = await chatClient.queryChannels({id: chatId});
      const chat = results.length > 0 ? results[0] : {};
      let exist = false;
      chatList.map(({data}) => {
        data.map(channel => {
          if (channel.id === chat.id) {
            exist = true;
            channel = chat;
            channel.dataChat = getChatChannelData(channel);
          }
        });
      });
      if (!exist) {
        chat.dataChat = getChatChannelData(chat);
        const { data } = chat;
        const { typeChannel } = data;
        const chatType = ['direct', 'group'].includes(typeChannel) ? 'custom' : typeChannel;
        chatList.map((element) => {
          if (element.type === chatType) {
            element.data.unshift(chat);
          }
        });
        updateTotalMessagesUnread(chatList);
      }
      setChatList([...chatList]);
      if (selectedChannel) {
        selectedChannel.map((channel) => {
          if (channel.id === chat.id) {
            channel = chat;
            channel.dataChat = getChatChannelData(channel);
          }
        });
        setSelectedChannel([...selectedChannel]);
      }
      setLoading(false);
    }
  };

  const getPrevMessages = async (channel) => {
    const oldMessages = channel.dataChat.messages || channel.state.messages;
    if (oldMessages.length > 0) {
      let channels = selectedChannel || [];
      let channelIndex = -1;
      channels.map((chat, index) => {
        if (chat.id === channel.id) {
          channelIndex = index;
        }
      });
      setLoading(true);
      const query = await channel.query({
        messages: { limit: 100, id_lt: oldMessages[0].id }
      });
      const messages = query ? query.messages : [];
      messages.map(message => {
        message.created_at = new Date(message.created_at);
      });
      channel.dataChat.messages = messages.concat(oldMessages);
      channel.messageLink = undefined;
      channels[channelIndex] = channel;
      setSelectedChannel([...channels]);
      setLoading(false);
    }
  }

  const getNextMessages = async (channel) => {
    const oldMessages = channel.dataChat.messages || channel.state.messages;
    if (oldMessages.length > 0) {
      let channels = selectedChannel || [];
      let channelIndex = -1;
      channels.map((chat, index) => {
        if (chat.id === channel.id) {
          channelIndex = index;
        }
      });
      setLoading(true);
      const query = await channel.query({
        messages: { limit: 100, id_gt: oldMessages[oldMessages.length-1].id }
      });
      const messages = query ? query.messages : [];
      messages.map(message => {
        message.created_at = new Date(message.created_at);
      });
      channel.dataChat.messages = oldMessages.concat(messages);
      channel.messageLink = undefined;
      channels[channelIndex] = channel;
      setSelectedChannel([...channels]);
      setLoading(false);
    }
  }

  const createDirectChat = async (selectedUser) => {
    const { user } = chatClient;
    let members = [];
    let membersChannel = [];
    if (Array.isArray(selectedUser)) {
      selectedUser.forEach((val)=>{
        if (!isNaN(val.id)) {
          return [ members.push(parseInt(val.id)), membersChannel.push(val.id) ];
        }
      });
    }
    else {
      if (!isNaN(selectedUser.id)) {
        members.push(parseInt(selectedUser.id));
        membersChannel.push(selectedUser.id);
      }
    }
    membersChannel.push(String(user.id));

    const channels = await chatClient.queryChannels(
      { members: { $eq: membersChannel }, type: 'messaging', $or: [ { hidden : true }, { hidden : false } ] },
      { last_message_at: -1 },
      { limit: 1 });
    if (channels.length > 0) {
      await channels[0].show();
      await updateChannelList(channels[0].id);
      return channels[0];
    }
    else {
      let result = null;
      const newChatId = await ChatCanalService.create({ members : members });
      let newChat = await chatClient.queryChannels({ id: newChatId }, { last_message_at: -1 }, {
            watch: true,
            state: true,
        });
      if (newChat.length > 0) {
        await newChat[0].show();
        result = newChat[0];
        await updateChannelList(result.id);
      }
      return result;
    }
  };

  const deleteDirectChat = async (channel) => {
    onRemoveSelectChat(channel);
    await channel.delete();

    await onRemoveChat(channel);
  };

  const exitDirectChat = async (channel) => {
    onRemoveSelectChat(channel);
    if (channel.state.membership.is_moderator){
      await channel.delete();
    }
    else {
      await channel.removeMembers([currentUser.id]);
    }

    await onRemoveChat(channel);
  };

  const removeMembersChat = async (channel, users) => {
    const members = users.map((item) => {
      return String(item.id);
    });
    await channel.removeMembers(members);
    if (channel.data.member_count <= 1) {
      await onRemoveChat(channel);
      await channel.delete();
    }
    else {
      await updateChannelList(channel.id);
    }
  };

  const addMembersChat = async (channel, users) => {
    const members = users.map((item) => {
      return String(item.id);
    });
    await channel.addMembers(members);
    await updateChannelList(channel.id);
  };

  const searchChatList = async (searchKey) => {
    let list = [];

    if (searchKey) {
      setLoading(true);
      const search = await chatClient.search(
         filters,
         searchKey,
         { limit: 10, offset: 0 },
      );

      let messageChats = [];
      let messagesLink = {};
      if (search && search.results) {
        search.results.map(result => {
          if (!messageChats.includes(result.message.channel.id)) {
            messageChats.push(result.message.channel.id);
          }
          if (!messagesLink[result.message.channel.id]) {
            messagesLink[result.message.channel.id] = [];
          }
          messagesLink[result.message.channel.id].push({id:result.message.id, text: result.message.text});
        });
      }

      const filtersChats = { $or: [ { name: { $autocomplete: searchKey } } ] };
      if (messageChats.length > 0) {
        const messageQuery = { id: { $in: messageChats } };
        filtersChats['$or'].push(messageQuery);
      }

      const channels = await chatClient.queryChannels(filtersChats, { last_message_at: -1 }, {
          watch: true,
          state: true,
      });
      const channelIds = channels.map(item => item.id);
      chatList.map((chats) => {
        chats.data.filter((chat) => {
          if (channelIds.includes(chat.id)) {
            if (messagesLink[chat.id]) {
              messagesLink[chat.id].map(link => {
                let linkChat = {...chat, messageLink: link};
                list.push(linkChat);
              });
            }
            else {
              chat.messageLink = undefined;
              list.push(chat);
            }
          }
        });
      });
      setLoading(false);
    }
    else {
      chatList.map((chats) => {
        chats.data.filter((chat) => {
          chat.messageLink = undefined;
        });
      });
    }
    
    return list;
  };

  const searchUserList = async (searchKey, excludeMembers) => {
    const accountsIds = accounts.map((account) => [account.id]);
    let exludeIds = [currentUser.id];
    if (excludeMembers) {
      excludeMembers.map((member) => {
        exludeIds.push(String(member.user ? member.user.id : member.id));
      });
    }
    return await chatClient.queryUsers(
      {
        id: { $nin: exludeIds },
        name: { $autocomplete: searchKey },
        is_active: true,
        accounts: { $in: accountsIds }
        },
      { id: -1 },
      { presence: true }
    );
  };

  const searchRecentList = async (excludeMembers) => {
    const accountsIds = accounts.map((account) => [account.id]);
    let exludeIds = [currentUser.id];
    let limit = 10;
    if (excludeMembers) {
      excludeMembers.map((member) => {
        exludeIds.push(String(member.user ? member.user.id : member.id));
      });
      limit += excludeMembers.length;
    }
    const filter = {...filters, type: 'messaging' };
    const sort = { last_message_at: -1 };

    const channels = await chatClient.queryChannels(filter, sort, {
      watch: true,
      state: true,
      limit: limit,
    });
    let validIds = [];
    channels.map((channel) => {
      if (channel.dataChat) {
        channel.dataChat.memberList.map((member) => {
          if (!exludeIds.includes(member.user.id) && !validIds.includes(member.user.id) && validIds.length < 5) {
            validIds.push(member.user.id);
          }
        });
      }
    });
    let queryUsers = {};
    if (validIds.length > 0) {
      let users = [];
      queryUsers = await chatClient.queryUsers(
        { id: { $in: validIds }, is_active: true },
        { last_active: -1 },
        { limit: validIds.length, presence: true }
      );
      validIds.forEach((id) => {
        queryUsers.users.forEach((user) => {
          if (id === user.id) {
            users.push(user);
          }
        });
      });
      queryUsers.users = users;
    }
    else {
      queryUsers = await chatClient.queryUsers(
      {
        id: { $nin: exludeIds },
        accounts: { $in: accountsIds },
        is_active: true
        },
      { last_active: -1 },
      { limit: 5, presence: true }
      );
    }
    return queryUsers;
  };

  const onSelectChatExpand = (channel) => {
    let channels = selectedChannelExpand || [];
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    if (channelIndex < 0) {
      channels.push(channel);
      setSelectedChannelExpand([...channels]);
      setlastChannel(channel);
    }
  };

  const onRemoveChatExpand = (channel) => {
    let channels = selectedChannelExpand || [];
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    if (channelIndex >= 0) {
      channels.splice(channelIndex, 1);
      setSelectedChannelExpand([...channels]);
    }
  };

  const onSelectChatActive = (channel) => {
    let channels = selectedChannelActive || [];
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    if (channelIndex < 0) {
      channels.push(channel);
      setSelectedChannelActive([...channels]);
      setlastChannel(channel);
    }
  };

  const onRemoveChatActive = (channel) => {
    let channels = selectedChannelActive || [];
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    if (channelIndex >= 0) {
      channels.splice(channelIndex, 1);
      setSelectedChannelActive([...channels]);
      onRemoveChatExpand(channel);
    }
  };
  
  const onSelectChat = async (channel) => {
    let channels = selectedChannel || [];
    let selectChat = channel;
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    chatList.map((chats) => {
      chats.data.filter((chat) => {
        if (chat.id === selectChat.id) {
          selectChat = chat;
          selectChat.messageLink = channel.messageLink;
        }
      });
    });
    if (selectChat.messageLink) {
      setLoading(true);
      const result = await selectChat.query({
        messages: { limit: 100, id_gte: selectChat.messageLink.id }
      });
      const messages = result ? result.messages : null;
      if (messages) {
        messages.map(message => {
          message.created_at = new Date(message.created_at);
        });
      }
      selectChat.dataChat.messages = messages;
      setLoading(false);
    }
    else {
      selectChat.dataChat.messages = null;
    }
    if (channelIndex < 0) {
      channels.unshift(selectChat);
      setSelectedChannel([...channels]);
      onSelectChatActive(selectChat);
    }
    else {
      channels[channelIndex] = selectChat;
      setSelectedChannel([...channels]);
    }
  };

  const onRemoveSelectChat = (channel) => {
    let channels = selectedChannel || [];
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    if (channelIndex >= 0) {
      channels.splice(channelIndex, 1);
      setSelectedChannel([...channels]);
      onRemoveChatActive(channel);
    }
  };

  const onRemoveChat = async (channel) => {
    let channels = chatList || [];
    let channelIndex = -1;
    let groupIndex = -1;
    channels.map(({data}, indexGroup) => {
      data.map((chat, index) => {
        if (chat.id === channel.id) {
          channelIndex = index;
          groupIndex = indexGroup;
        }
      });
    });

    if (channelIndex >= 0) {
      channels[groupIndex].data.splice(channelIndex, 1);
      updateTotalMessagesUnread(channels);
      setChatList([...channels]);
    }
  };

  const removeLinkChannel = (channel) => {
    let channels = selectedChannel || [];
    let channelIndex = -1;
    channels.map((chat, index) => {
      if (chat.id === channel.id) {
        channelIndex = index;
      }
    });
    channel.messageLink = undefined;
    channels[channelIndex] = channel;
    setSelectedChannel([...channels]);
  }

  const onSetMemberList = (members) => { setMemberList(members) };

  return (
    <ChatStreamContext.Provider value={{ 
      options,
      showNotificationBanner,
      theme: {},
      chatClient,
      filters,
      chatList,
      currentUser,
      selectedChannel,
      selectedChannelActive,
      selectedChannelExpand,
      memberList,
      lastChannel,
      totalMessagesUnread,
      loading,
      setUser,
      getChannelList,
      updateChannelMessages,
      getPrevMessages,
      getNextMessages,
      updateChannelList,
      getChatChannelData,
      checkChannelCustom,
      getChannelType,
      createDirectChat,
      deleteDirectChat,
      exitDirectChat,
      removeMembersChat,
      addMembersChat,
      searchChatList,
      searchUserList,
      searchRecentList,
      clearChatContext,
      onSelectChat,
      onSelectChatActive,
      onSelectChatExpand,
      onRemoveSelectChat,
      onRemoveChatActive,
      onRemoveChatExpand,
      onSetMemberList,
      removeLinkChannel
    }}>
      {props.children}
    </ChatStreamContext.Provider>
  )
};

export default ChatStreamContextProvider;